"use strict";
var Observable_1 = require("rxjs/Observable");
var throughNodeStream_1 = require("../../operator/throughNodeStream");
Observable_1.Observable.prototype.throughNodeStream = throughNodeStream_1.throughNodeStream;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhyb3VnaE5vZGVTdHJlYW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWRkL29wZXJhdG9yL3Rocm91Z2hOb2RlU3RyZWFtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw4Q0FBNkM7QUFDN0Msc0VBQXFFO0FBRXJFLHVCQUFVLENBQUMsU0FBUyxDQUFDLGlCQUFpQixHQUFHLHFDQUFpQixDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/rx-extra/add/operator/throughNodeStream.js
// module id = 409
// module chunks = 0